var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBusinessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3477_17746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 10.3297V46.5479L27 54.0449L0 46.5479V10.3297C0 8.59492 0.76275 6.96367 2.09475 5.85442C2.142 5.81392 2.2005 5.78917 2.25 5.75092V44.8379L27 51.7072L51.75 44.8379V5.75092C51.7995 5.78917 51.8558 5.81392 51.9053 5.85442C53.2373 6.96592 54 8.59717 54 10.3297ZM27 47.2949L6.75 41.5079V7.87717C6.75 6.09517 7.56675 4.45942 8.98875 3.38617C10.413 2.31292 12.2107 1.98217 13.9207 2.46817L23.346 5.16142C24.8738 5.59792 26.1518 6.56542 27 7.82767C27.8482 6.56542 29.1262 5.59792 30.654 5.16142L40.0793 2.46817C41.7892 1.97992 43.5892 2.31292 45.0112 3.38617C46.4332 4.45942 47.25 6.09742 47.25 7.87717V41.5079L27 47.2949ZM28.125 44.6332L45 39.8114V7.87717C45 6.80842 44.5095 5.82517 43.6567 5.18167C43.0605 4.73392 42.354 4.49992 41.634 4.49992C41.3213 4.49992 41.0085 4.54492 40.698 4.63267L31.2705 7.32592C29.4187 7.85467 28.125 9.57142 28.125 11.4974V44.6332ZM25.875 11.4974C25.875 9.56917 24.5813 7.85242 22.7295 7.32592L13.3043 4.63267C12.276 4.33792 11.2005 4.53817 10.3455 5.18167C9.49275 5.82517 9.00225 6.80842 9.00225 7.87717V39.8114L25.8773 44.6332V11.4974H25.875Z",
    fill: "#0073FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3477_17746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessIcon);
export default __webpack_public_path__ + "static/media/business-icon.3e3ca704fb883f502b7b2e873f68a865.svg";
export { ForwardRef as ReactComponent };